import { Box, Button, Flex, VStack, HStack, Text, Avatar, IconButton } from "@chakra-ui/react";
import React, { useState } from "react";
import { IoMdCamera } from "react-icons/io";
import { useUploadProfileImg } from "../../../services/employeeService";
import { FiUpload, FiCamera } from "react-icons/fi";

const UploadProfileImg = ({ filebase64, inputData, inputRef, convertFile, setInputData, onClose, setImgUpload }) => {
    const cloud_name = process.env.REACT_APP_CLOUD_NAME || "drgenfwdh";
    const preset_key = process.env.REACT_APP_PRESET_KEY || "emanagement_img_preset";

    const [img, setImg] = useState()
  const { uploadIsLoading, uploadPayload } = useUploadProfileImg(
    (res) => {
      setInputData({...inputData, profile_image: res?.secure_url})
      setImgUpload(false)
      onClose()
    }
  );


  const handleUpload = async() => {
    const file = img[0]
    const formData = new FormData()
    formData.append("file", file)
    formData.append("upload_preset", preset_key)

    try {
        const data = {
            payload: formData,
            cloudName : cloud_name
        }
    const res = await uploadPayload(data)

    if (res) {
        return "success"
    }
    } catch (error) {
    }
  }

  return (
    <VStack spacing={6} align="center">
      {/* Header */}
      <VStack spacing={2}>
        <Text fontSize="lg" fontWeight="600" color="gray.900">
          Upload Profile Photo
        </Text>
        <Text fontSize="sm" color="gray.500" textAlign="center">
          Choose a clear photo for the employee's profile
        </Text>
      </VStack>

      {/* Image Upload Area */}
      <Box position="relative">
        <Avatar
          size="2xl"
          src={filebase64 ? filebase64 : inputData?.profile_image}
          name={`${inputData?.first_name} ${inputData?.last_name}`}
          border="3px solid"
          borderColor="gray.200"
        />
        <IconButton
          icon={<FiCamera />}
          size="sm"
          colorScheme="blue"
          borderRadius="full"
          position="absolute"
          bottom={0}
          right={0}
          onClick={() => inputRef.current.click()}
          _hover={{ transform: "scale(1.1)" }}
          transition="all 0.2s"
        />
      </Box>

      {/* File Input */}
      <input
        type="file"
        onChange={(e) => {
          setImg(e.target.files);
          return convertFile(e.target.files);
        }}
        ref={inputRef}
        style={{ display: "none" }}
      />

      {/* Upload Button */}
      <VStack spacing={4} w="100%">
        <Button
          colorScheme="blue"
          size="md"
          borderRadius="12px"
          fontWeight="600"
          leftIcon={<FiUpload />}
          onClick={handleUpload}
          isLoading={uploadIsLoading}
          loadingText="Uploading..."
          w="100%"
          _hover={{ transform: "translateY(-1px)", boxShadow: "md" }}
          transition="all 0.2s"
        >
          Upload Photo
        </Button>
        
        <Text fontSize="xs" color="gray.500" textAlign="center">
          Supported formats: JPG, PNG, GIF (Max 5MB)
        </Text>
      </VStack>
    </VStack>
  );
};

export default UploadProfileImg;
